import React, { memo } from 'react'

import { Icon, RocketGradient } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

const rocketIconSize = { width: '24px', height: '24px' }

// "N of M simultaneous generations available" plan notice under the progress bar.
function SlotsNotice() {
  const t = useTranslation()
  const concurrencyCap = useThreeDStudioStore(state => state.subscription.concurrencyCap)
  const activeRunCount = useThreeDStudioStore(state => state.generation.activeRuns.length)

  if (!concurrencyCap || concurrencyCap < 1) {
    return null
  }

  const available = Math.max(concurrencyCap - activeRunCount, 0)

  return (
    <div className="slots-notice">
      <div className="slots-notice__icon-box">
        <Icon svgComponent={RocketGradient} size={rocketIconSize} notSpaced />
      </div>
      <p className="slots-notice__text cgt-body-base">
        <span className="cgt-body-base-semibold">
          {t('viewer.banner.slotsNotice.highlight', { available, total: concurrencyCap })}
        </span>
        {' '}
        {t('viewer.banner.slotsNotice.rest')}
      </p>
    </div>
  )
}

export default memo(SlotsNotice)
